import { render, staticRenderFns } from "./BankViewBankPlanCard.vue?vue&type=template&id=1567c195"
import script from "./BankViewBankPlanCard.vue?vue&type=script&lang=js"
export * from "./BankViewBankPlanCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports